import React, {useState, useEffect} from "react";
import { useHistory } from "react-router-dom";

const Favorites = (props) => {
    const [favorites, setFavorites] = useState(props.favorites)
    let history = useHistory();

    useEffect(() => {
        const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        let mockFaves = 
            [
                {
                    context: "site",
                    label: "NMSD Sonora",
                    link: "/locations/1012"
                },
                {
                    context: "site",
                    label: "NMSD HarborView",
                    link: "/locations/1008"
                },
                {
                    context: "site",
                    label: "PUSD Piedmont",
                    link: "/locations/1026"
                },
                {
                    context: "site",
                    label: "BSD Triangle Lake",
                    link: "/locations/1032"
                },
                {
                    context: "site",
                    label: "FPSD Franklin Pierce",
                    link: "/locations/1009"
                },
                {
                    context: "site",
                    label: "Jen's Test Exploratorium",
                    link: "/locations/22"

                },
                {
                    context: "site",
                    label: "Tracy's Zoo",
                    link: "/locations/1031"

                },
                {
                    context: "site",
                    label: "CEL Test Site",
                    link: "/locations/1033"
                },
            ]
        if (width < 500) mockFaves = mockFaves.slice(0, 4)
        setFavorites(mockFaves)
    }, [])


    const drawFavorite = (f) => {

        let className = "favorite " + f.context;
        return (
            <div className={className} key={f.label} onClick={() => {
                history.push(f.link)
            }}>
                <div className="favorite-label">{f.label}</div>
            </div>
        )
    }

    return (
        <div className="favorites">
            {
                favorites && favorites.map((f) => {
                    return drawFavorite(f);
                })
            }
        </div>

    )

}

export default Favorites;
